import { type ReactElement, useEffect } from "react";

import type { ModalComponent } from "./modal-builder";
import { useUserTriggeredModalsStore } from "./user-triggered-modals.store";

interface ModalProps<Props, M extends ModalComponent<Props>> {
  deduplicationKey?: string;
  children: ReactElement<Props, M>;
}

export const Modal = <Props, M extends ModalComponent<Props>>({ deduplicationKey, children }: ModalProps<Props, M>) => {
  const modalOwnId: string | undefined = children?.type?.modalId;
  const targetId = modalOwnId ? (deduplicationKey ? `${modalOwnId}-${deduplicationKey}` : modalOwnId) : null;

  const setChildren = useUserTriggeredModalsStore((state) => state.setChildren);

  useEffect(() => {
    if (!targetId) {
      return;
    }

    setChildren(targetId, children);
  }, [setChildren, targetId, children]);

  return null;
};
